import cookieConsent from 'services/cookies-consent'
import initButtonVisibility from 'landings/__assets__/scripts/components/scroll-button'
import { initCountersObserver } from 'landings/__assets__/scripts/components/counters-animation'
import { scrollToElement } from 'landings/__assets__/scripts/components/scroll-to-element'
import initForm from 'landings/__assets__/scripts/components/form-handling-competition'

initButtonVisibility()
initForm()
cookieConsent.init()
initCountersObserver()
scrollToElement()
